/* eslint-disable import/no-anonymous-default-export */
import axios from "axios";
import AuthService from "./AuthService";

class DanfeService {
    constructor() {
        this.apiUrl = process.env.REACT_APP_API_URL || "https://portalrelacionamentoapi.dev-gam.com";
    }

   async getListaNotasFiscais(cdCliente, filtros) {
    try {
        // Autentica��o
        if (!AuthService.getToken()) {
            await AuthService.login();
        }

        const url = `${this.apiUrl}/nota-fiscal/listar/${cdCliente}`;
        console.log("URL da requisi��o:", url);
        console.log("Filtros enviados:", JSON.stringify(filtros, null, 2));

        const response = await axios.post(
            url,
            filtros, // Envia o objeto `filtros` no corpo da requisi��o
            {
                headers: {
                    Authorization: `Bearer ${AuthService.getActiveToken()}`,
                },
            }
        );

        const conteudo = response.data.conteudo;
        console.log("Conte�do retornado:", conteudo);

        return conteudo;
    } catch (error) {
        console.error("Erro ao buscar lista de notas fiscais:", error.response?.data || error.message);
        throw new Error("Erro ao buscar lista de notas fiscais.");
    }
}


    async consultarReferenciaComplementar(cdCliente, dsChave) {
        try {
            if (!AuthService.getToken()) {
                await AuthService.login();
            }

            const response = await axios.get(
                `${this.apiUrl}/nota-fiscal-consulta/consultar-referencia-complementar`,
                {
                    headers: {
                        Authorization: `Bearer ${AuthService.getActiveToken()}`,
                    },
                    params: { cdCliente, dsChave },
                }
            );

            return response.data.conteudo;
        } catch (error) {
            console.error("Erro ao consultar referência complementar:", error.response?.data || error.message);
            throw new Error("Erro ao consultar referência complementar.");
        }
    }

    async getVisualizarNotaFiscal(cliente, nfe, nrSerie) {
        try {
            // Autentica��o
            if (!AuthService.getToken()) {
                //console.log("Token n�o encontrado. Realizando login...");
                await AuthService.login();
            }

            //console.log(
            // `Buscando nota fiscal: ${nfe}, S�rie: ${nrSerie}, Cliente: ${cliente}`
            // );
            const response = await axios.get(
                `${this.apiUrl}/nota-fiscal/exibir/${cliente}/${nfe}/${nrSerie}`,
                {
                    headers: {
                        Authorization: `Bearer ${AuthService.getActiveToken()}`,
                    },
                    responseType: "blob", // Configura para receber um Blob
                }
            );

            //console.log("Resposta do servidor recebida:", response);
            // Retorna o Blob diretamente
            return response.data;
        } catch (error) {
            console.error("Erro ao buscar visualiza��o de nfe:", error);
            throw new Error("Erro ao buscar visualiza��o de nfe.");
        }
    }
}

export default new DanfeService();
